import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { openPopupWindow } from 'cityads-v3/utils/htmlUtils';

import ShareButton from './ShareButton';

export default class TelegramShareButton extends PureComponent {
  static propTypes = {
    url: PropTypes.string,
  }

  render() {
    const { url } = this.props;

    return (
      <ShareButton
        icon    = {require('./TelegramShareButton.png')}
        onClick = {(evt) => {
          openPopupWindow({
            url: `https://t.me/share/url?url=${encodeURIComponent(url)}`,
            width: 600,
            height: 400
          });
          evt.stopPropagation();
        }}
        {...this.props}
      />
    );
  }
}
